import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Apropos = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };
  
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }, []);

  const slides = [
    { 
      id: 1, 
      className: "single_slider about_bg_1",
      style:{ 
        backgroundImage: "url('/assets/img/IMG_5106.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center bottom', 
        height: '400px',
        width: '100%' 
      }
    },
    { 
      id: 2, 
      className: "single_slider about_bg_1",
      style: { 
        backgroundImage: "url('/assets/img/IMG_5110.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center bottom', 
        height: '400px',
        width: '100%' 
      }
    },
    { 
      id: 3, 
      className: "single_slider about_bg_1",
      style: { 
        backgroundImage: "url('/assets/img/banner/banner.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center bottom', 
        height: '400px',
        width: '100%' 
      }
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);
    
    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const goToPrev = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <>
      <div 
        className="bradcam_area breadcam_bg"
        data-aos="fade-down"
        data-aos-delay="200"
      >
        <h3>About Club les Pins</h3>
      </div>

      <div className="about_area">
        <div className="container">
          <div className="row">
            <div className="col-xl-5 col-lg-5">
              <div 
                className="about_info"
                data-aos="fade-right"
                data-aos-delay="300"
              >
                <div className="section_title mb-20px">
                  <span>About Us</span>
                  <h3>Luxury Apartment-Hotel and Hotel Villas</h3>
                </div>
                <p data-aos="fade-up" data-aos-delay="400">
                  The hotel extends over an area of 15,503 m², accessible via the northern scenic road. It is bordered by the golf course to the south, east, and west, offering breathtaking views of the Mediterranean Sea and the golf course.
                </p>
                <a 
                  href="#" 
                  className="line-button"
                  data-aos="fade-up"
                  data-aos-delay="500"
                >
                  See more
                </a>
              </div>
            </div>
            <div className="col-xl-7 col-lg-7">
              <div className="about_thumb d-flex">
                <div 
                  className="img_1"
                  data-aos="zoom-in"
                  data-aos-delay="400"
                >
                  <img src="assets/img/about/about_1.png" alt="About hotel"/>
                </div>
                <div 
                  className="img_2"
                  data-aos="zoom-in"
                  data-aos-delay="600"
                >
                  <img src="assets/img/about/about_2.png" alt="Hotel view"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div 
        className="about_info_area"
        data-aos="fade-up"
        data-aos-delay="300"
      >
        <div className="about_active" style={{ position: 'relative' }}>
          
          <div 
            className={slides[currentSlide].className}
            style={slides[currentSlide].style}
          />       
          
          {/* Flèches de navigation */}
          <button 
            onClick={goToPrev}
            style={{
              position: 'absolute',
              left: '20px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(0,0,0,0.5)',
              color: 'white',
              border: 'none',
              width: '50px',
              height: '50px',
              padding: '0',
              cursor: 'pointer',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '20px',
              fontWeight: 'bold',
              zIndex: 10
            }}
          >
            ‹
          </button>

          <button 
            onClick={goToNext}
            style={{
              position: 'absolute',
              right: '20px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(0,0,0,0.5)',
              color: 'white',
              border: 'none',
              width: '50px',
              height: '50px',
              padding: '0',
              cursor: 'pointer',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '20px',
              fontWeight: 'bold',
              zIndex: 10
            }}
          >
            ›
          </button>
          
          <div style={{
            position: 'absolute',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            gap: '10px'
          }}>
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                style={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  border: 'none',
                  background: currentSlide === index ? '#333' : '#ccc',
                  cursor: 'pointer'
                }}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="about_main_info" style={{ 
        padding: '80px 0', 
        background: '#ffffff',
        position: 'relative'
      }}>
        <div className="container">
          <div className="text-center mb-5" data-aos="fade-down" data-aos-delay="200">
            <div style={{
              display: 'inline-block',
              position: 'relative'
            }}>
              <span style={{
                color: '#1E6EA7',
                fontSize: '14px',
                fontWeight: '600',
                letterSpacing: '3px',
                textTransform: 'uppercase',
                marginBottom: '10px',
                display: 'block'
              }}>
                Excellence & Distinction
              </span>
              <h2 style={{
                color: '#2C3E50',
                fontSize: '32px',
                fontWeight: '300',
                margin: '0'
              }}>
                Our <span style={{ fontWeight: '400', color: '#1E6EA7' }}>Signature</span> Features
              </h2>
            </div>
          </div>

          <div className="row align-items-start">
            <div 
              className="col-xl-6 col-md-6"
              data-aos="fade-right"
              data-aos-delay="300"
            >
              <div style={{
                background: '#F8FAFC',
                padding: '40px',
                borderRadius: '12px',
                height: '100%',
                border: '1px solid #E1E8F0',
                position: 'relative',
                boxShadow: '0 4px 6px rgba(30, 110, 167, 0.1)'
              }}>
                <div style={{
                  position: 'absolute',
                  top: '-15px',
                  left: '30px',
                  background: 'linear-gradient(135deg, #1E6EA7, #2A8CD4)',
                  color: 'white',
                  padding: '8px 20px',
                  borderRadius: '20px',
                  fontSize: '12px',
                  fontWeight: '600',
                  letterSpacing: '1px',
                  boxShadow: '0 2px 4px rgba(30, 110, 167, 0.3)'
                }}>
                  HOTEL FACILITIES
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '30px'
                }}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    background: 'linear-gradient(135deg, #1E6EA7, #2A8CD4)',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '20px',
                    boxShadow: '0 4px 8px rgba(30, 110, 167, 0.3)'
                  }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19 7H5C3.89543 7 3 7.89543 3 9V20H21V9C21 7.89543 20.1046 7 19 7Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M8 10V12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M16 10V12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M7 17H9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M15 17H17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div>
                    <h3 style={{
                      color: '#2C3E50',
                      fontSize: '24px',
                      fontWeight: '500',
                      margin: '0 0 5px 0'
                    }}>
                      Luxury Resort
                    </h3>
                    <p style={{
                      color: '#5D6D7E',
                      fontSize: '14px',
                      margin: '0'
                    }}>
                      Premium accommodation & amenities
                    </p>
                  </div>
                </div>

                <div className="features-list">
                  <div style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    marginBottom: '25px',
                    padding: '20px',
                    background: 'white',
                    borderRadius: '10px',
                    borderLeft: '4px solid #1E6EA7',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                    transition: 'all 0.3s ease'
                  }}>
                    <div style={{
                      width: '40px',
                      height: '40px',
                      background: '#F0F7FF',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '15px',
                      border: '1px solid #D1E3F8'
                    }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 21H16" stroke="#1E6EA7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M12 17V21" stroke="#1E6EA7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M6 13H18L20 5H4L6 13Z" stroke="#1E6EA7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M4 5L6 13" stroke="#1E6EA7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M20 5L18 13" stroke="#1E6EA7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <div>
                      <h4 style={{
                        color: '#2C3E50',
                        fontSize: '16px',
                        fontWeight: '600',
                        marginBottom: '8px'
                      }}>
                        Ground Floor
                      </h4>
                      <p style={{
                        color: '#5D6D7E',
                        fontSize: '14px',
                        lineHeight: '1.5',
                        margin: '0'
                      }}>
                        Elegant reception, boutique, jazz bar, and breakfast room with adjacent kitchen
                      </p>
                    </div>
                  </div>

                  <div style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    marginBottom: '25px',
                    padding: '20px',
                    background: 'white',
                    borderRadius: '10px',
                    borderLeft: '4px solid #1E6EA7',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                    transition: 'all 0.3s ease'
                  }}>
                    <div style={{
                      width: '40px',
                      height: '40px',
                      background: '#F0F7FF',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '15px',
                      border: '1px solid #D1E3F8'
                    }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 12L12 16L8 12" stroke="#1E6EA7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M12 8V16" stroke="#1E6EA7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M20 6C20 7.65685 16.4183 9 12 9C7.58172 9 4 7.65685 4 6C4 4.34315 7.58172 3 12 3C16.4183 3 20 4.34315 20 6Z" stroke="#1E6EA7" strokeWidth="2"/>
                        <path d="M20 12C20 13.6569 16.4183 15 12 15C7.58172 15 4 13.6569 4 12" stroke="#1E6EA7" strokeWidth="2"/>
                        <path d="M20 18C20 19.6569 16.4183 21 12 21C7.58172 21 4 19.6569 4 18" stroke="#1E6EA7" strokeWidth="2"/>
                      </svg>
                    </div>
                    <div>
                      <h4 style={{
                        color: '#2C3E50',
                        fontSize: '16px',
                        fontWeight: '600',
                        marginBottom: '8px'
                      }}>
                        Upper Levels
                      </h4>
                      <p style={{
                        color: '#5D6D7E',
                        fontSize: '14px',
                        lineHeight: '1.5',
                        margin: '0'
                      }}>
                        Variety of rooms, swimming pool, and intimate bar on the 2nd floor
                      </p>
                    </div>
                  </div>

                  <div style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    padding: '20px',
                    background: 'white',
                    borderRadius: '10px',
                    borderLeft: '4px solid #1E6EA7',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                    transition: 'all 0.3s ease'
                  }}>
                    <div style={{
                      width: '40px',
                      height: '40px',
                      background: '#F0F7FF',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '15px',
                      border: '1px solid #D1E3F8'
                    }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 21C16.4183 21 20 17.4183 20 13C20 8.58172 16.4183 5 12 5C7.58172 5 4 8.58172 4 13C4 17.4183 7.58172 21 12 21Z" stroke="#1E6EA7" strokeWidth="2"/>
                        <path d="M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z" stroke="#1E6EA7" strokeWidth="2"/>
                        <path d="M12 13V13.01" stroke="#1E6EA7" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </div>
                    <div>
                      <h4 style={{
                        color: '#2C3E50',
                        fontSize: '16px',
                        fontWeight: '600',
                        marginBottom: '8px'
                      }}>
                        Basement Level
                      </h4>
                      <p style={{
                        color: '#5D6D7E',
                        fontSize: '14px',
                        lineHeight: '1.5',
                        margin: '0'
                      }}>
                        Complete service facilities, multipurpose hall, and luxury SPA center
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div 
              className="col-xl-6 col-md-6"
              data-aos="fade-left"
              data-aos-delay="400"
            >
              <div style={{
                background: 'linear-gradient(135deg, #1A5276 0%, #2E86C1 100%)',
                padding: '40px',
                borderRadius: '12px',
                height: '100%',
                position: 'relative',
                color: 'white',
                boxShadow: '0 4px 6px rgba(30, 110, 167, 0.2)'
              }}>
                <div style={{
                  position: 'absolute',
                  top: '-15px',
                  left: '30px',
                  background: 'linear-gradient(135deg, #1E6EA7, #2A8CD4)',
                  color: 'white',
                  padding: '8px 20px',
                  borderRadius: '20px',
                  fontSize: '12px',
                  fontWeight: '600',
                  letterSpacing: '1px',
                  boxShadow: '0 2px 4px rgba(30, 110, 167, 0.3)'
                }}>
                  ARCHITECTURE
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '30px'
                }}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    background: 'rgba(255, 255, 255, 0.15)',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '20px',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    backdropFilter: 'blur(10px)'
                  }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 21H21" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                      <path d="M5 21V7L12 3L19 7V21" stroke="white" strokeWidth="2"/>
                      <path d="M9 21V13H15V21" stroke="white" strokeWidth="2"/>
                    </svg>
                  </div>
                  <div>
                    <h3 style={{
                      color: 'white',
                      fontSize: '24px',
                      fontWeight: '500',
                      margin: '0 0 5px 0'
                    }}>
                      Mediterranean Design
                    </h3>
                    <p style={{
                      color: '#E8F4FD',
                      fontSize: '14px',
                      margin: '0'
                    }}>
                      Inspired by Tabarka's coastal beauty
                    </p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-6 mb-4">
                    <div style={{
                      textAlign: 'center',
                      padding: '25px 15px',
                      background: 'rgba(255,255,255,0.1)',
                      borderRadius: '10px',
                      border: '1px solid rgba(255,255,255,0.15)',
                      transition: 'all 0.3s ease',
                      height: '100%',
                      backdropFilter: 'blur(5px)'
                    }}>
                      <div style={{
                        width: '50px',
                        height: '50px',
                        background: 'rgba(255, 255, 255, 0.2)',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 15px',
                        border: '1px solid rgba(255, 255, 255, 0.3)'
                      }}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2 12C2 12 5 7 12 7C19 7 22 12 22 12C22 12 19 17 12 17C5 17 2 12 2 12Z" stroke="white" strokeWidth="2"/>
                          <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="white" strokeWidth="2"/>
                        </svg>
                      </div>
                      <h4 style={{
                        color: 'white',
                        fontSize: '14px',
                        fontWeight: '600',
                        marginBottom: '8px'
                      }}>
                        Sea Front Access
                      </h4>
                      <p style={{
                        color: '#E8F4FD',
                        fontSize: '12px',
                        lineHeight: '1.4',
                        margin: '0'
                      }}>
                        Rooms opening directly to the sea
                      </p>
                    </div>
                  </div>

                  <div className="col-6 mb-4">
                    <div style={{
                      textAlign: 'center',
                      padding: '25px 15px',
                      background: 'rgba(255,255,255,0.1)',
                      borderRadius: '10px',
                      border: '1px solid rgba(255,255,255,0.15)',
                      transition: 'all 0.3s ease',
                      height: '100%',
                      backdropFilter: 'blur(5px)'
                    }}>
                      <div style={{
                        width: '50px',
                        height: '50px',
                        background: 'rgba(255, 255, 255, 0.2)',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 15px',
                        border: '1px solid rgba(255, 255, 255, 0.3)'
                      }}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 9L12 2L21 9V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V9Z" stroke="white" strokeWidth="2"/>
                          <path d="M9 21V13H15V21" stroke="white" strokeWidth="2"/>
                        </svg>
                      </div>
                      <h4 style={{
                        color: 'white',
                        fontSize: '14px',
                        fontWeight: '600',
                        marginBottom: '8px'
                      }}>
                        Private Villas
                      </h4>
                      <p style={{
                        color: '#E8F4FD',
                        fontSize: '12px',
                        lineHeight: '1.4',
                        margin: '0'
                      }}>
                        Exclusive villa collection
                      </p>
                    </div>
                  </div>

                  <div className="col-6">
                    <div style={{
                      textAlign: 'center',
                      padding: '25px 15px',
                      background: 'rgba(255,255,255,0.1)',
                      borderRadius: '10px',
                      border: '1px solid rgba(255,255,255,0.15)',
                      transition: 'all 0.3s ease',
                      height: '100%',
                      backdropFilter: 'blur(5px)'
                    }}>
                      <div style={{
                        width: '50px',
                        height: '50px',
                        background: 'rgba(255, 255, 255, 0.2)',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 15px',
                        border: '1px solid rgba(255, 255, 255, 0.3)'
                      }}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 9L12 2L21 9V20H3V9Z" stroke="white" strokeWidth="2"/>
                          <path d="M9 21V13H15V21" stroke="white" strokeWidth="2"/>
                        </svg>
                      </div>
                      <h4 style={{
                        color: 'white',
                        fontSize: '14px',
                        fontWeight: '600',
                        marginBottom: '8px'
                      }}>
                        Traditional Roofs
                      </h4>
                      <p style={{
                        color: '#E8F4FD',
                        fontSize: '12px',
                        lineHeight: '1.4',
                        margin: '0'
                      }}>
                        Red brick-colored tiles
                      </p>
                    </div>
                  </div>

                  <div className="col-6">
                    <div style={{
                      textAlign: 'center',
                      padding: '25px 15px',
                      background: 'rgba(255,255,255,0.1)',
                      borderRadius: '10px',
                      border: '1px solid rgba(255,255,255,0.15)',
                      transition: 'all 0.3s ease',
                      height: '100%',
                      backdropFilter: 'blur(5px)'
                    }}>
                      <div style={{
                        width: '50px',
                        height: '50px',
                        background: 'rgba(255, 255, 255, 0.2)',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 15px',
                        border: '1px solid rgba(255, 255, 255, 0.3)'
                      }}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z" stroke="white" strokeWidth="2"/>
                          <path d="M14 2V8H20" stroke="white" strokeWidth="2"/>
                          <path d="M16 13H8" stroke="white" strokeWidth="2"/>
                          <path d="M16 17H8" stroke="white" strokeWidth="2"/>
                          <path d="M10 9H9H8" stroke="white" strokeWidth="2"/>
                        </svg>
                      </div>
                      <h4 style={{
                        color: 'white',
                        fontSize: '14px',
                        fontWeight: '600',
                        marginBottom: '8px'
                      }}>
                        Natural Design
                      </h4>
                      <p style={{
                        color: '#E8F4FD',
                        fontSize: '12px',
                        lineHeight: '1.4',
                        margin: '0'
                      }}>
                        White walls & wood tones
                      </p>
                    </div>
                  </div>
                </div>

                <div style={{
                  marginTop: '30px',
                  padding: '20px',
                  background: 'rgba(255, 255, 255, 0.15)',
                  borderRadius: '8px',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  textAlign: 'center',
                  backdropFilter: 'blur(5px)'
                }}>
                  <p style={{
                    color: '#E8F4FD',
                    fontSize: '14px',
                    margin: '0 0 10px 0'
                  }}>
                    Experience authentic Mediterranean architecture
                  </p>
                  <button onClick={(e) => { e.preventDefault(); handleNavigation('/gallery'); }} style={{
                    background: 'rgba(255, 255, 255, 0.9)',
                    color: '#1E6EA7',
                    border: 'none',
                    padding: '10px 25px',
                    borderRadius: '6px',
                    fontSize: '13px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = 'white';
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'rgba(255, 255, 255, 0.9)';
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }
                }
                  >
                    View Gallery
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
          .features-list > div:hover {
            transform: translateX(5px);
            box-shadow: 0 5px 15px rgba(30, 110, 167, 0.15) !important;
            border-left: 4px solid #2A8CD4 !important;
          }
          
          .row > .col-6 > div:hover {
            transform: translateY(-5px);
            background: rgba(255,255,255,0.2) !important;
            box-shadow: 0 8px 16px rgba(0,0,0,0.2) !important;
          }
          
          @media (max-width: 768px) {
            .about_main_info {
              padding: 50px 0 !important;
            }
            
            .col-xl-6 {
              margin-bottom: 30px;
            }
          }
        `}</style>
      </div>

      <div 
        className="forQuery"
        data-aos="fade-up"
        data-aos-delay="300"
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-10 offset-xl-1 col-md-12">
              <div className="Query_border">
                <div className="row align-items-center justify-content-center">
                  <div 
                    className="col-xl-6 col-md-6"
                    data-aos="fade-right"
                    data-aos-delay="400"
                  >
                    <div className="Query_text">
                      <p>For a Reservation or an Inquiry?</p>
                    </div>
                  </div>
                  <div 
                    className="col-xl-6 col-md-6"
                    data-aos="fade-left"
                    data-aos-delay="500"
                  >
                    <div className="phone_num">
                      <a 
                        href="/contact" 
                        onClick={(e) => { e.preventDefault(); handleNavigation('/contact'); }} 
                        className="mobile_no"
                      >
                        +216 98 370 055
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="instragram_area">
        <div 
          className="single_instagram"
          data-aos="zoom-in"
          data-aos-delay="200"
        >
          <img src="assets/img/instragram/1.png" alt="Instagram 1"/>
          <div className="ovrelay">
            <a href="#">
              <i className="fa fa-instagram"></i>
            </a>
          </div>
        </div>
        <div 
          className="single_instagram"
          data-aos="zoom-in"
          data-aos-delay="300"
        >
          <img src="assets/img/instragram/2.png" alt="Instagram 2"/>
          <div className="ovrelay">
            <a href="#">
              <i className="fa fa-instagram"></i>
            </a>
          </div>
        </div>
        <div 
          className="single_instagram"
          data-aos="zoom-in"
          data-aos-delay="400"
        >
          <img src="assets/img/instragram/3.png" alt="Instagram 3"/>
          <div className="ovrelay">
            <a href="#">
              <i className="fa fa-instagram"></i>
            </a>
          </div>
        </div>
        <div 
          className="single_instagram"
          data-aos="zoom-in"
          data-aos-delay="500"
        >
          <img src="assets/img/instragram/4.png" alt="Instagram 4"/>
          <div className="ovrelay">
            <a href="#">
              <i className="fa fa-instagram"></i>
            </a>
          </div>
        </div>
        <div 
          className="single_instagram"
          data-aos="zoom-in"
          data-aos-delay="600"
        >
          <img src="assets/img/instragram/5.png" alt="Instagram 5"/>
          <div className="ovrelay">
            <a href="#">
              <i className="fa fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Apropos;



{/* import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Import AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

const Apropos = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };
  
  const navigate = useNavigate();

  // Initialiser AOS
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }, []);

  const slides = [
    { 
      id: 1, 
      className: "single_slider about_bg_1",
      style:{ 
        backgroundImage: "url('/assets/img/IMG_5106.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center bottom', 
        height: '400px',
        width: '100%' 
      }
    },
    { 
      id: 2, 
      className: "single_slider about_bg_1",
      style: { 
        backgroundImage: "url('/assets/img/IMG_5110.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center bottom', 
        height: '400px',
        width: '100%' 
      }
    },
    { 
      id: 3, 
      className: "single_slider about_bg_1",
      style: { 
        backgroundImage: "url('/assets/img/banner/banner.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center bottom', 
        height: '400px',
        width: '100%' 
      }
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);
    
    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const goToPrev = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <>
      <div 
        className="bradcam_area breadcam_bg"
        data-aos="fade-down"
        data-aos-delay="200"
      >
        <h3>About Club les Pins</h3>
      </div>

      <div className="about_area">
        <div className="container">
          <div className="row">
            <div className="col-xl-5 col-lg-5">
              <div 
                className="about_info"
                data-aos="fade-right"
                data-aos-delay="300"
              >
                <div className="section_title mb-20px">
                  <span>About Us</span>
                  <h3>Luxury Apartment-Hotel and Hotel Villas</h3>
                </div>
                <p data-aos="fade-up" data-aos-delay="400">
                  The hotel extends over an area of 15,503 m², accessible via the northern scenic road. It is bordered by the golf course to the south, east, and west, offering breathtaking views of the Mediterranean Sea and the golf course.
                </p>
                <a 
                  href="#" 
                  className="line-button"
                  data-aos="fade-up"
                  data-aos-delay="500"
                >
                  See more
                </a>
              </div>
            </div>
            <div className="col-xl-7 col-lg-7">
              <div className="about_thumb d-flex">
                <div 
                  className="img_1"
                  data-aos="zoom-in"
                  data-aos-delay="400"
                >
                  <img src="assets/img/about/about_1.png" alt="About hotel"/>
                </div>
                <div 
                  className="img_2"
                  data-aos="zoom-in"
                  data-aos-delay="600"
                >
                  <img src="assets/img/about/about_2.png" alt="Hotel view"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div 
        className="about_info_area"
        data-aos="fade-up"
        data-aos-delay="300"
      >
        <div className="about_active" style={{ position: 'relative' }}>
          
          <div 
            className={slides[currentSlide].className}
            style={slides[currentSlide].style}
          />       
          
          <button 
            onClick={goToPrev}
            style={{
              position: 'absolute',
              left: '20px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(0,0,0,0.5)',
              color: 'white',
              border: 'none',
              width: '50px',
              height: '50px',
              padding: '0',
              cursor: 'pointer',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '20px',
              fontWeight: 'bold',
              zIndex: 10
            }}
          >
            ‹
          </button>

          <button 
            onClick={goToNext}
            style={{
              position: 'absolute',
              right: '20px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(0,0,0,0.5)',
              color: 'white',
              border: 'none',
              width: '50px',
              height: '50px',
              padding: '0',
              cursor: 'pointer',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '20px',
              fontWeight: 'bold',
              zIndex: 10
            }}
          >
            ›
          </button>
          
          <div style={{
            position: 'absolute',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            gap: '10px'
          }}>
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                style={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  border: 'none',
                  background: currentSlide === index ? '#333' : '#ccc',
                  cursor: 'pointer'
                }}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="about_main_info">
        <div className="container">
          <div className="row">
            <div 
              className="col-xl-6 col-md-6"
              data-aos="fade-right"
              data-aos-delay="300"
            >
              <div className="single_about_info">
                <h3>A Luxury Apartment-Hotel<br/>
                    and Hotel Villas</h3>
                <p style={{whiteSpace: 'pre-line'}}>
                  {`The ground floor features a reception, a boutique, a jazz bar, a breakfast 
room with an adjacent kitchen, and a few rooms.
The upper floors house various types of rooms, a swimming pool, and a small bar on the 2nd floor.
The basement is divided into two parts: one dedicated to service, including a kitchen, a dining hall, laundry room, male/female changing rooms, 
and service parking; the other houses a reception, a multipurpose hall, 
ancillary rooms, and a SPA center. `}
                </p>
              </div>
            </div>
            <div 
              className="col-xl-6 col-md-6"
              data-aos="fade-left"
              data-aos-delay="400"
            >
              <div className="single_about_info">
                <h3> Mediterranean Architecture <br/>
                     Inspired by Tabarka</h3>
                <p style={{whiteSpace: 'pre-line'}}>
                  {`An apartment-hotel with rooms that open directly onto the sea.
Villas of various types with direct access to the apartment-hotel.
Sloping roofs covered with red brick-colored tiles, white walls, 
and carpentry in green or natural wood tones.`}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div 
        className="forQuery"
        data-aos="fade-up"
        data-aos-delay="300"
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-10 offset-xl-1 col-md-12">
              <div className="Query_border">
                <div className="row align-items-center justify-content-center">
                  <div 
                    className="col-xl-6 col-md-6"
                    data-aos="fade-right"
                    data-aos-delay="400"
                  >
                    <div className="Query_text">
                      <p>For a Reservation or an Inquiry?</p>
                    </div>
                  </div>
                  <div 
                    className="col-xl-6 col-md-6"
                    data-aos="fade-left"
                    data-aos-delay="500"
                  >
                    <div className="phone_num">
                      <a 
                        href="/contact" 
                        onClick={(e) => { e.preventDefault(); handleNavigation('/contact'); }} 
                        className="mobile_no"
                      >
                        +216 98 370 055
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="instragram_area">
        <div 
          className="single_instagram"
          data-aos="zoom-in"
          data-aos-delay="200"
        >
          <img src="assets/img/instragram/1.png" alt="Instagram 1"/>
          <div className="ovrelay">
            <a href="#">
              <i className="fa fa-instagram"></i>
            </a>
          </div>
        </div>
        <div 
          className="single_instagram"
          data-aos="zoom-in"
          data-aos-delay="300"
        >
          <img src="assets/img/instragram/2.png" alt="Instagram 2"/>
          <div className="ovrelay">
            <a href="#">
              <i className="fa fa-instagram"></i>
            </a>
          </div>
        </div>
        <div 
          className="single_instagram"
          data-aos="zoom-in"
          data-aos-delay="400"
        >
          <img src="assets/img/instragram/3.png" alt="Instagram 3"/>
          <div className="ovrelay">
            <a href="#">
              <i className="fa fa-instagram"></i>
            </a>
          </div>
        </div>
        <div 
          className="single_instagram"
          data-aos="zoom-in"
          data-aos-delay="500"
        >
          <img src="assets/img/instragram/4.png" alt="Instagram 4"/>
          <div className="ovrelay">
            <a href="#">
              <i className="fa fa-instagram"></i>
            </a>
          </div>
        </div>
        <div 
          className="single_instagram"
          data-aos="zoom-in"
          data-aos-delay="600"
        >
          <img src="assets/img/instragram/5.png" alt="Instagram 5"/>
          <div className="ovrelay">
            <a href="#">
              <i className="fa fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Apropos; */}